import React, { Component } from 'react';
import PeriodicTable from "./components/PeriodicTable";

class App extends Component {
  render() {
    return (
      <PeriodicTable/>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js